import React, { useMemo } from 'react';

import { Icon, SVG } from 'components/tokens/Icon';
import { Colors } from 'enums/Colors';
import useMediaQuery from 'utils/useMediaQuery';
import { Modal } from 'components/Modal';
import { questionCircle } from 'icons/default';

import styles from './ConditionItem.module.scss';

export interface IConditionItem {
  color?: Colors;
  colorIconModalOpen?: Colors;
  limit?: number;
  stepColor?: Colors;
  title: string;
  titleIcon?: SVG;
  text: string;
}

const getBorderRadius = (index: number) => {
  switch (true) {
    case index === 0:
      return '0.5rem 0 0 0.5rem';
    case index === 3:
      return '0 0.5rem 0.5rem 0';
    default:
      return '';
  }
};

export const ConditionItem: React.VFC<IConditionItem> = ({
  color = Colors.White,
  stepColor = Colors.Yellowish500,
  colorIconModalOpen = Colors.DarkBlue100,
  limit = 0,
  title,
  titleIcon = null,
  text,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const Steps = useMemo(() => {
    const stepsArray: JSX.Element[] = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= 3; i++) {
      stepsArray.push(
        <span
          key={`step-item-${i}`}
          className={styles.step}
          style={{
            backgroundColor: `var(--color-${limit >= i ? stepColor : Colors.DarkBlue100})`,
            borderRadius: getBorderRadius(i),
          }}
        />
      );
    }
    return stepsArray;
  }, [limit, stepColor]);

  return (
    <div>
      <div className={styles['title-wrapper']} style={{ color: `var(--color-${color})` }}>
        <h2 className={styles.title}>
          {titleIcon ? <Icon icon={titleIcon} color={color} size={22} /> : null}
          {title}
        </h2>
        {isMobile ? (
          <Modal
            ButtonContent={<Icon color={colorIconModalOpen} icon={questionCircle} size={16} />}
          >
            {text}
          </Modal>
        ) : null}
      </div>
      <div className={styles['step-wrapper']}>{Steps}</div>
      {!isMobile ? (
        <div className={styles['text-wrapper']} style={{ color: `var(--color-${color})` }}>
          {text}
        </div>
      ) : null}
    </div>
  );
};
